import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { getConfig } from 'utils/config'
import { parse } from 'date-fns'

export const HIERARCHY_UPLOAD_GET = 'HIERARCHY_UPLOAD_GET'
export const HIERARCHY_UPLOAD_RECEIVED = 'HIERARCHY_UPLOAD_RECEIVED'
export const HIERARCHY_UPLOAD_GET_ERROR = 'HIERARCHY_UPLOAD_GET_ERROR'
export const HIERARCHY_UPLOAD_DELETE_RECEIVED = 'HIERARCHY_UPLOAD_DELETE_RECEIVED'
export const HIERARCHY_UPLOAD_DELETE_COMPLETE = 'HIERARCHY_UPLOAD_DELETE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const hierarchyUploadReceive = (uploads, locked) => ({
  type: HIERARCHY_UPLOAD_RECEIVED,
  uploads,
  locked,
})

const mapHierarchyUpload = (result) => {
  const docLib = getConfig().HIERARCHY_UPLOAD
  const docLibLogs = getConfig().HIERARCHY_UPLOAD_LOG
  const uploaded = result.map(uploads => ({
    itemId: uploads.ItemID,
    path: uploads.URL,
    logPath: (uploads.URL ? uploads.URL.replace(docLib, docLibLogs).replace('.csv', '.log') : ''),
    status: uploads.Status,
    documentName: uploads.Name,
    created: uploads.Created,
    modified: uploads.Modified,
    modifiedDate: parse(uploads.Modified, constants.DATE_FORMAT.SPO_FORMAT, new Date()),
  }))

  return uploaded.sort((a, b) => b.modifiedDate - a.modifiedDate)
}

export function sendNotification(message) {
  return (dispatch) => {
    dispatch(notify(message))
  }
}

export function getHierarchyUpload() {
  return (dispatch) => {
    dispatch(fetching(HIERARCHY_UPLOAD_GET))

    agent.PartnerHierarchy.getuploads().then((uploads) => {
      dispatch(hierarchyUploadReceive(mapHierarchyUpload(uploads)))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerPlanRatings>: ', error)
        dispatch(fetchingerror(HIERARCHY_UPLOAD_GET_ERROR))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/hierarchyUpload.js